import React from 'react';
import TutorialProgressBanner from './ui/TutorialProgressBanner';

const TutorialChecklist = () => {
  return <TutorialProgressBanner />;
};

export default TutorialChecklist; 